export default __webpack_public_path__ + "40e4c9a117dbf191ed9cdd58b3b0bd67.png";